import React, { useEffect } from 'react'
import { UseGetStoreData } from '../getStoreData/UseGetStoreData';
import { getSingleBenDetails } from '../../pages/actions/actions';
import { useDispatch } from 'react-redux';
interface BenDataPros {
    patient_id: string;
    field:any
}

const DEFAULT_INSURER = [{ nameOfInsurer: "N/A" }];

const useBenDataByField= ({ patient_id,field }:BenDataPros) => {
    const dispatch = useDispatch();
    const { getBenList } = UseGetStoreData();
    const [benData, setBenData] = React.useState<any>(null);
    //if benData is not found, make an API call to fetch the data//
    useEffect(() => {
        if (!patient_id) return;
        const existingBen = getBenList?.find((ben: any) => ben?._id === patient_id);

        if (existingBen) {
            setBenData(existingBen);
        } else {
            (async () => {
                //fallback_case_:
                await getSingleBenDetails(patient_id, dispatch);

            })();
        }
    }, [patient_id, getBenList, dispatch]);  
    ///after getting benData need to send the details from argument field
    return { data: benData ? (benData[field] ?? DEFAULT_INSURER) : DEFAULT_INSURER };
}

export default useBenDataByField;
